import { Quote } from "../../../api/Quote/Quote";
import { TF } from "../../../components/typography/TF";

interface Props {
  quote: Quote | null;
}

const QuoteTopPrice = ({ quote }: Props) => {
  if (quote === null) {
    return null;
  }

  return (
    <TF variant="h3" bold format="price">
      {quote.price}
    </TF>
  );
};

export default QuoteTopPrice;
